import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogContent: {
    overflow: 'visible',
  },
  dialogPaper: {
    overflow: 'visible',
    margin: 'auto',
  },
  formItem: {
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
  formLabel: {
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium,
  },
  characterCounter: {},
  textField: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0,
      width: '100%',
    },
    '& .MuiInputBase-multiline': {
      width: '100%',
    },
  },
  listItem: {
    marginTop: '8px',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
});
